// TODO: Find good way to test federated modules loading
/* istanbul ignore file */
import { useLocation, useNavigate } from 'react-router-dom';
import { lazy, useMemo } from 'react';
import type { UnicornApi } from '@cld/unicorn-api';
import { RemoteModule } from '../../components/remote-module/remote-module';
import { useMessage } from '../../i18n/useMessage';
import { useMediaExplorerCustomerIdEffect } from './media-explorer.hooks';

const defaultEventCategory = 'media explorer';

type MediaExplorerModule = Awaited<typeof import('@cld-remote/media_explorer/index')>;

const RemoteMediaExplorer = lazy(() =>
  import('@cld-remote/media_explorer/index').then(({ MediaExplorer }: MediaExplorerModule) => ({
    // TODO: Install and use https://github.com/module-federation/universe/tree/main/packages/typescript
    default: MediaExplorer,
  }))
);

export default function MediaExplorer({ shouldDisplayThumbnails, unicornApi }: { shouldDisplayThumbnails?: boolean; unicornApi: UnicornApi }) {
  const { productEnvironment } = unicornApi.data;

  const t = useMessage();
  const location = useLocation();
  const navigate = useNavigate();

  useMediaExplorerCustomerIdEffect();

  const customerInfo = useMemo(
    () => ({
      apiKey: productEnvironment.apiKey ?? '',
      cloudName: productEnvironment.cloudName,
      customerExternalId: productEnvironment.externalId,
    }),
    [productEnvironment]
  );

  return (
    // TODO: Add Media Explorer skeleton
    <RemoteModule documentTitle={t('media-explorer')}>
      <RemoteMediaExplorer
        // TODO: Remove props that rely on unicornApi here when possible
        key={productEnvironment.externalId /* FIXME: media explorer does not clean up current state on data reload, duplicating data */}
        customerInfo={customerInfo}
        location={location}
        navigate={navigate}
        onTrack={({ eventAction, eventCategory = defaultEventCategory, eventLabel }) =>
          unicornApi.methods.sendAnalytics({
            variant: 'universal',
            data: { action: eventAction, category: eventCategory, label: eventLabel },
          })
        }
        shouldDisplayThumbnails={shouldDisplayThumbnails}
        unicornApi={unicornApi}
      />
    </RemoteModule>
  );
}
